export default [
  {
   date: "22-02-2022",
   day: "monday",
   time: "12:00",
   end: "4:00"
  },
  
];
